export const portalEmailDefaults = {
  registration: {
    subject: "Welcome to {{salon_name}} - set your password",
    body:
      "Hi {{client_first_name}},\n" +
      "Your client account at {{salon_name}} is ready.\n" +
      "To finish setting up your account, please create your password here:\n" +
      "{{set_password_url}}\n" +
      "You can sign in anytime here: {{portal_login_url}}\n" +
      "If you need help, call us at {{salon_phone}}.\n" +
      "Thank you,\n" +
      "{{signature_name}}",
  },
  password_reset: {
    subject: "Reset your {{salon_name}} password",
    body:
      "Hi {{client_first_name}},\n" +
      "We received a request to reset your password for {{salon_name}}.\n" +
      "Use this link to reset your password:\n" +
      "{{reset_password_url}}\n" +
      "If you did not request this, you can ignore this email.\n" +
      "Need help? Call us at {{salon_phone}}.\n" +
      "Thank you,\n" +
      "{{signature_name}}",
  },
};

export const portalEmailFieldHelp = {
  registration_toggle:
    "Use a custom subject and message for the registration email.",
  registration_subject: "Subject line for the registration email.",
  registration_body: "Message body for the registration email.",
  password_toggle:
    "Use a custom subject and message for the password reset email.",
  password_subject: "Subject line for the password reset email.",
  password_body: "Message body for the password reset email.",
};

export const portalEmailTooltips = {
  use_custom_message: "When off, Ellyanna uses the default message.",
  subject: "Customize the subject line clients see.",
  body: "Customize the message clients see.",
  tokens: "Click to copy a token or insert it into your message.",
  preview: "Preview uses sample values.",
};
